module.exports = __webpack_public_path__ + "img/calendar-days.cf1badd2.svg";